// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__i7BQ0","menuPositions":"Menu_menuPositions__X2xQW","noMenuContainer":"Menu_noMenuContainer__ZLP3M","noMenuDescription":"Menu_noMenuDescription__ywEj0"};